import { createFileRoute } from "@tanstack/react-router"
import DesignSystemToast from "~/pages/design-system/components/Toast"

export const Route = createFileRoute("/_auth/internal/design-system/components/toast")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemToast />
}
